import { instanceWithAuth } from './index'

function getAttendanceList(yearMonth) {
  return instanceWithAuth.get('/mobile/atdc', {
    params: {
      yearMonth: yearMonth,
    },
  })
}

function getAttendanceStatus() {
  return instanceWithAuth.post('/mobile/atdc')
}

function attendance() {
  return instanceWithAuth.post('/mobile/atdc/check')
}

// 강의 출석 여부 조회
function selectAtdcStatus() {
  return instanceWithAuth.get()
}

// 시간표 조회
function getTimetable(_yearTerm) {
  return instanceWithAuth.get('/mobile/atdc/time', {
    params: {
      yearTerm: _yearTerm,
    },
  })
}

// 강의목록

// 강의 공지사항 리스트조회
function getLecNoticeList() {
  return instanceWithAuth.get('/mobile/atdc/notice')
}

export {
  getAttendanceList,
  getAttendanceStatus,
  attendance,
  getTimetable,
  getLecNoticeList,
}
